import { render, staticRenderFns } from "./BigScreen.vue?vue&type=template&id=48cc303b&scoped=true&"
import script from "./BigScreen.vue?vue&type=script&lang=ts&"
export * from "./BigScreen.vue?vue&type=script&lang=ts&"
import style0 from "./BigScreen.vue?vue&type=style&index=0&id=48cc303b&prod&lang=scss&"
import style1 from "./BigScreen.vue?vue&type=style&index=1&id=48cc303b&prod&lang=scss&scoped=true&"
import style2 from "./BigScreen.vue?vue&type=style&index=2&id=48cc303b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc303b",
  null
  
)

export default component.exports